export default {
  scenes: {
    glimpseOfEnemy: {
      beats: {
        revealingMastermind: {
          events: [
            {
              type: 'showLocation',
              locationId: 'abandonedStation'
            },
            {
              type: 'showNarration',
              text: 'After a long and brutal firefight, Elena and her crew finally manage to repel the mercenaries, though not without casualties. As they search the station\'s control room, they find a mysterious figure hiding behind a security panel.'
            },
            {
              type: 'showCharacter',
              characterId: 'nyx',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'The figure reveals themselves as Captain Nyx, a former officer who was thought to have died in a past mission gone wrong.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena react to Nyx\'s sudden appearance?',
              choices: [
                {
                  text: 'Confront Nyx Directly',
                  next: {
                    scene: 'glimpseOfEnemy',
                    beat: 'confrontNyx'
                  }
                },
                {
                  text: 'Keep Calm and Assess the Situation',
                  next: {
                    scene: 'glimpseOfEnemy',
                    beat: 'assessSituation'
                  }
                }
              ]
            }
          ]
        },
        confrontNyx: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'nyx',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'You were supposed to be dead! What\'s your game, Nyx?'
            },
            {
              type: 'showDialog',
              speaker: 'nyx',
              variation: 'neutral',
              text: 'You never knew the whole story, Elena. I\'ve been working on something bigger than you could ever imagine.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'nyx',
              position: 'right'
            },
            {
              type: 'showNarration',
              text: 'Nyx reveals that she was behind the sabotage of the Solaris and that her ultimate plan is to seize control of the uncharted sector and its vast resources. She believes that Elena\'s crew is standing in her way and that her methods will bring about a new era of control and power.'
            },
            {
              type: 'showCharacter',
              characterId: 'nyx',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'nyx',
              variation: 'neutral',
              text: 'The resources hidden in this sector belong to a select few. I plan to claim them, with or without your approval.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'You\'re risking everything for power, Nyx. You\'ve lost all sense of what\'s right.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'nyx',
              position: 'center'
            }
          ],
          next: {
            scene: 'undercoverAgent',
            beat: 'unexpectedAlliance'
          }
        },
        assessSituation: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'nyx',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Why don\'t you explain yourself, Nyx? What have you been planning?'
            },
            {
              type: 'showDialog',
              speaker: 'nyx',
              variation: 'neutral',
              text: 'I\'m not here to answer your questions. But maybe I\'ll give you a glimpse of what\'s coming.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'nyx',
              position: 'right'
            },
            {
              type: 'showNarration',
              text: 'Nyx reveals that she was behind the sabotage of the Solaris and that her ultimate plan is to seize control of the uncharted sector and its vast resources. She believes that Elena\'s crew is standing in her way and that her methods will bring about a new era of control and power.'
            },
            {
              type: 'showCharacter',
              characterId: 'nyx',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'nyx',
              variation: 'neutral',
              text: 'The resources hidden in this sector belong to a select few. I plan to claim them, with or without your approval.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'You\'re risking everything for power, Nyx. You\'ve lost all sense of what\'s right.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'nyx',
              position: 'center'
            }
          ],
          next: {
            scene: 'undercoverAgent',
            beat: 'unexpectedAlliance'
          }
        }
      }
    },
    undercoverAgent: {
      beats: {
        unexpectedAlliance: {
          events: [
            {
              type: 'showNarration',
              text: 'As Nyx continues to rant about her plans, Elena\'s second-in-command, Zara, steps forward. She reveals that she has been working as an undercover agent for a special organization tasked with stopping rogue officers like Nyx. Zara\'s loyalties come into question as Elena grapples with this revelation.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena react to Zara\'s betrayal?',
              choices: [
                {
                  text: 'Show Trust in Zara',
                  next: {
                    scene: 'undercoverAgent',
                    beat: 'trustZara'
                  }
                },
                {
                  text: 'Feel Betrayed by Zara',
                  next: {
                    scene: 'undercoverAgent',
                    beat: 'feelBetrayed'
                  }
                }
              ]
            }
          ]
        },
        trustZara: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'surprised',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'surprised',
              text: 'You\'ve been working against us this whole time? Why didn\'t you tell me, Zara?'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'sad',
              text: 'I never wanted to hurt you, Captain. I had no choice.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'right'
            },
            {
              type: 'showNarration',
              text: 'Zara explains that her mission was always to protect the crew, even if it meant deceiving Elena. She claims that she was placed in a difficult position and had no other choice but to act as Nyx\'s confidante in order to gain vital intelligence.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'sad',
              text: 'I never wanted you to know the truth, Elena. But I couldn\'t keep lying to you.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'You could\'ve told me, Zara. I would\'ve fought with you.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'center'
            }
          ],
          next: {
            scene: 'brokenBond',
            beat: 'decisionToMoveForward'
          }
        },
        feelBetrayed: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'How could you, Zara? You\'ve been lying to me all along.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'angry',
              text: 'I was doing what was necessary! I never wanted this to get personal.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'right'
            },
            {
              type: 'showNarration',
              text: 'Zara explains that her mission was always to protect the crew, even if it meant deceiving Elena. She claims that she was placed in a difficult position and had no other choice but to act as Nyx\'s confidante in order to gain vital intelligence.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'sad',
              text: 'I never wanted you to know the truth, Elena. But I couldn\'t keep lying to you.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'You could\'ve told me, Zara. I would\'ve fought with you.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'center'
            }
          ],
          next: {
            scene: 'brokenBond',
            beat: 'decisionToMoveForward'
          }
        }
      }
    },
    brokenBond: {
      beats: {
        decisionToMoveForward: {
          events: [
            {
              type: 'showNarration',
              text: 'The tension between Elena and Zara reaches a boiling point. Elena is torn between her trust for Zara and the harsh truth of her actions. They must decide whether they will continue working together or if the team is too divided to function as one.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Does Elena forgive Zara, or does she let the betrayal drive a wedge between them?',
              choices: [
                {
                  text: 'Forgive Zara and Move Forward Together',
                  next: {
                    scene: 'brokenBond',
                    beat: 'forgiveZara'
                  }
                },
                {
                  text: 'Leave Zara Behind and Move On',
                  next: {
                    scene: 'brokenBond',
                    beat: 'leaveZara'
                  }
                }
              ]
            }
          ]
        },
        forgiveZara: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'I don\'t know if I can fully trust you again, Zara. But we need to finish this, together.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'happy',
              text: 'Thank you, Captain. I swear I won\'t let you down.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'right'
            },
            {
              type: 'showNarration',
              text: 'Whether Elena forgives Zara or decides to part ways, the crew must now face the consequences of their actions. Nyx\'s plans are still a looming threat, and they are running out of time to stop her. The mission is far from over, and Elena knows that her next choices will determine the future of their entire crew.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We have a job to finish. And we\'re going to do it, no matter what.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'We\'ll follow you, Captain. We always will.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'kael',
              position: 'right'
            }
          ],
          goToChapter: {
            chapter: 'chapter4'
          }
        },
        leaveZara: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'You made your choice, Zara. We can\'t continue together anymore.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'sad',
              text: 'I understand, Captain.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'right'
            },
            {
              type: 'showNarration',
              text: 'Whether Elena forgives Zara or decides to part ways, the crew must now face the consequences of their actions. Nyx\'s plans are still a looming threat, and they are running out of time to stop her. The mission is far from over, and Elena knows that her next choices will determine the future of their entire crew.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We have a job to finish. And we\'re going to do it, no matter what.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'We\'ll follow you, Captain. We always will.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'kael',
              position: 'right'
            }
          ],
          goToChapter: {
            chapter: 'chapter4'
          }
        }
      }
    }
  }
}
